<div class="panel-box">
  <div class="pb-header justify-content-between align-items-center d-flex">
    <span [translate]="'profile.paymentPreferences.header'">Billing info</span>

    <span class="px-2 float-end">
      <ui-action-result
        [successTransKey]="'profile.paymentPreferences.saved'"
        [source]="isSaved"></ui-action-result>
    </span>
  </div>

  <div class="pb-content">
    <p class="font-sm" *ngIf="!(userInvoiceInfo$ | async)"
       [translate]="'profile.paymentPreferences.intro'">
      If you are business customer you can provide your usual
      invoice info to make the ordering process as simple as possible!</p>

    <user-invoice-info
      [(isValid)]="isInvoiceInfoValid"
      [paymentInfo]="paymentInfo"
      [bakeryId]="bakeryId"
      [user]="(user$ | async)"
      [showRemove]="true"
      [invoiceInfo]="(userInvoiceInfo$ | async)"
      [invoiceRefRequired]="false"
      (onInvoiceUpdated)="isSaved = true"
    ></user-invoice-info>
  </div>
</div>
